
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './UserProperties.html?raw';
import topic from 'dojo/topic';

import domStyle from 'dojo/dom-style';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import "../../../moreCore/UI/Toaster_TS/Toaster";
/*
import ExtendedCalendar = require("../ExtendedCalendar/ExtendedCalendar");
import "../ExtendedCalendar/ExtendedCalendar";
*/
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import "../../../moreCore/UI/SelectBox/SelectBox";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";



class UserProperties extends compose(_WidgetBaseSP) {
    templateString: any = template;

    //Nodes --------------------------------START
    calendarConfigSelectContainer: HTMLElement;
    calendarConfigSelect: MdsLax<InstanceType<typeof SelectBox>>;
    //Nodes --------------------------------END
    ////properties --------------------------------START

    //calendar: ExtendedCalendar;
    calendarConfigs: Array<WebcalendarTypes.WebCalendar_Config> = [];
    currentCalendarConfig: WebcalendarTypes.WebCalendar_Config = null;
    sessionData: object = null;
    ////properties --------------------------------END
    // own methods --------------------------------START

    private __requestUrl: string = "Calendar/GetUserProperties";
    private __requestParams: Object = {};


    private _initiate(): void {

        //console.debug("userproperties _initiate calendar", this._initiated);

        if (this._initiate == null || this._initiated === true) {
            return;
        }

        this._initiated = true;

        //this.calendarConfigSelect.setLabel(this.sessionData["UserDisplayName"]);
        this.calendarConfigSelect.setLabel(this.translations["WebCalendar_SidebarLabel_CalenderSelect"]);

        topic.publish("UserProperties/createCalendar"),

        this.loadEvisCalendarConfigurations();
    }


    // load Confi -----------------------START

    private loadEvisCalendarConfigurations(): void {



        let requestParams = this.prepareRequestParams();

        this.RequestManager.post(
            window.appRoot + this.__requestUrl,
            requestParams,
            lang.hitch(this, "_onGetUserProperties_Response"), //_saveRequestResponse
            lang.hitch(this, this._onGetUserProperties_Error)
        );
    }

    private _onGetUserProperties_Error(error: any) {
        topic.publish("UserProperties/errorLoading", error);
        console.error(error);
    }

    private _onGetUserProperties_Response (response:any): void {

        //console.log("userProperties_ response: ", response);

        if (response != null) {
            this.calendarConfigs = response;
            this._updateCalendarConfig();
        }

    }
    // load Confi -----------------------END

    // CalendarConfigSelect------------START

    private _updateCalendarConfig(): void {

        this.calendarConfigSelect.clear();

        domStyle.set(this.calendarConfigSelectContainer, "display", "block");

        let preselectedValue = this.getUrlParameterValue("sc");
        if (!preselectedValue) preselectedValue = this.__preselectedCalendardId;

        let confirmedPreset = null;

        for (var i = 0; i < this.calendarConfigs.length; i++) {
            var config: WebcalendarTypes.WebCalendar_Config = this.calendarConfigs[i];
            //var option = domConstruct.create("option", {
            //    value: node.ID,
            //    innerHTML: node.ref_web_calendar.description
            //}, this.calendarConfigSelectContainer, "last");

            this.calendarConfigSelect.addOption(config.ID, config.ref_web_calendar.description, true); /// addOption(value: string, label: string, isSelectable ?: boolean)/

            if (config.ID == preselectedValue) confirmedPreset = config.ID;
        }

        this.hideNode(this.calendarConfigSelectContainer, this.calendarConfigs.length <= 1);

        this.calendarConfigSelect.constructOptions();
        this.calendarConfigSelect.setValue(confirmedPreset ? confirmedPreset : this.calendarConfigs[0].ID); //// setValue(newValue: string, bSuppressChange?: boolean, forceIfDisabled?: boolean, delimiter?: string)/
        this._onChangeCalendarConfig(); // muss bleiben wegen SelectBox onchange problemme beim constructOptions

        //this._onCalendarConfigChanged(this.calendarConfigs[0]);
    }

    private _onChangeCalendarConfig(): void {

        var value: string = this.calendarConfigSelect.getValue();

        this.currentCalendarConfig = null;
        for (let config of this.calendarConfigs) {
            if (config.ID == value) {
                this.currentCalendarConfig = config;
                break;
            }
        }

        if (this.currentCalendarConfig) {
            this.onSelectCalendarConfig();
            if (this.getUrlParameterValue("sc") != this.currentCalendarConfig.ID) this.removeUrlParameter("sf");
            this.setUrlParameter("sc", this.currentCalendarConfig.ID);
        } else {
            this.removeUrlParameter("sc");
        }
    }

    private onSelectCalendarConfig(): void {
        topic.publish("UserProperties/calendarConfig", this.currentCalendarConfig);
    }

    // CalendarConfigSelect------------END
    setRequestUrl(url: string): void {
        this.__requestUrl = url;
    }

    private getRequestParams(): Object {
        let requestParams = {};
        return requestParams;
    }

    private __preselectedCalendardId: string;
    setSelectedCalendarId(calendarId: string) {
        if (!calendarId) return;

        this.__preselectedCalendardId = calendarId;

        // falls bereits geladen, dann Dropdown neue Wertzuweisung geben:
        if (this.calendarConfigs?.length) {
            this.calendarConfigSelect.setValue(this.__preselectedCalendardId);
        }
    }

    addRequestParam(name: string, value: any): void {
        let obj = this.__requestParams;

        obj[name] = value;
    }

    emptyRequestParams(): void {
        this.__requestParams = {};
    }

    removeRequestParams(): void {
        this.emptyRequestParams();
    }

    private prepareRequestParams(): any {
        let paramObj = {};
        let obj = this.__requestParams;
        for (let property in obj) {
            if (typeof (obj[property]) == "object") {
                paramObj[property.toString()] = JSON.stringify(obj[property]);
            }
            else {
                paramObj[property.toString()] = obj[property];
            }
        }

        //console.debug("userproperties prepareRequestParams", paramObj);
        return paramObj;
        //return JSON.stringify(this.requestUrl_additionalSearchParameter);
    }

    // own methods --------------------------------END
    //Lifecycle --------------------------------START

    _setupSubscriptions(): void {
        super._setupSubscriptions.apply(this, arguments as any);

        this._topics.push(topic.subscribe("/Session/CheckForExistingSession", lang.hitch(this, this._onOpenSession)));
    }

    private _initiated: boolean = false;
    private _doInitiate: boolean = false;
    private _tryInitiate(): void {
        if (this.sessionData == null) {
            return;
        }

        if (this._initiated === true) {
            return;
        }

        this._initiated = null;

        this._initiate();
    }

    private _onOpenSession(session: SessionData): void {

        //console.debug("userproperties onopensession", session, this._doInitiate, this._initiated);

        if (window.sessionInfo && window.sessionInfo.sessionData) {
            this.sessionData = window.sessionInfo.sessionData;
        }

        if (this._doInitiate === true) {
            this._tryInitiate();
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

        //this.addLiveCommandSubscription("pb-Webcalendar", lang.hitch(this, this._onProgress));


    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        this._doInitiate = true;

        // data-cy fuer die Kalenderauswahl (SelectBox) -> landet auf dem <select> (inputNode)
        if (this.calendarConfigSelect) {
            this.calendarConfigSelect.setCyName("calCalendarSelect");
        }

        //console.debug("userproperties startup", this._doInitiate, this.sessionData);

        setTimeout(lang.hitch(this, this._tryInitiate), 1000);

    }


}

export default mdsWidget(UserProperties);
